module.exports = __webpack_public_path__ + "static/img/rank_48.b40c464.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_48.png
// module id = qwrW
// module chunks = 1